import AuthenticationTracker from './authenticate';
import UserInfoTracker from './info';


export const authenticationTracker = new AuthenticationTracker();
export const userInfoTracker = new UserInfoTracker();
